import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import appSliceReducer from './app/app.reducer';
import equipmentReducer, { initialEquipmentState } from './equipment/equipment.reducer';
import type { EquipmentState } from './equipment/equipment.reducer';
import { keepEquipmentListPlace, loadEquipmentListPlace } from './equipment/equipment.storage';
import { AppState } from './app/app.state';
import { authApi } from '@services/authApi';
import { repApi } from '@services/repApi';

const rootReducer = combineReducers({
  app: appSliceReducer,
  equipment: equipmentReducer,
  [authApi.reducerPath]: authApi.reducer,
  [repApi.reducerPath]: repApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  // A refresh starts the Equipment table where this tab left it (organization, search and page).
  preloadedState: { equipment: { ...initialEquipmentState, ...loadEquipmentListPlace() } },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware, repApi.middleware),
  devTools: import.meta.env.MODE !== 'production',
});

setupListeners(store.dispatch);
keepEquipmentListPlace(store);

// Declared manually (instead of ReturnType<typeof rootReducer>) so services can
// cast getState() without a circular type inference.
export interface RootState {
  app: AppState;
  equipment: EquipmentState;
  [key: string]: unknown;
}

export type AppDispatch = typeof store.dispatch;
